// @mui
import { alpha, styled } from '@mui/material/styles';
import { ListItemText, ListItemButton, ListItemIcon } from '@mui/material';
// config
import { ICON, NAVBAR } from '../../../config';

// ----------------------------------------------------------------------

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'activeSub' && prop !== 'subItem',
})(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.body2,
  position: 'relative',
  height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
  textTransform: 'capitalize',
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2),
  marginBottom: theme.spacing(0.7),
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius * 1.5,
  transition: theme.transitions.create(['background', 'box-shadow', 'color', 'border'], {
    duration: theme.transitions.duration.shorter,
  }),
  // Glassmorphism effect on hover/active
  '&:hover': {
    background: theme.palette.mode === 'dark'
      ? `linear-gradient(90deg, ${alpha(theme.palette.primary.dark, 0.10)} 0%, ${alpha(theme.palette.background.paper, 0.7)} 100%)`
      : `linear-gradient(90deg, ${alpha(theme.palette.primary.lighter, 0.18)} 0%, #fff 100%)`,
    boxShadow: theme.shadows[2],
    color: theme.palette.primary.main,
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
  },
  // activeRoot
  ...(activeRoot && {
    ...theme.typography.subtitle2,
    color: theme.palette.primary.main,
    background: theme.palette.mode === 'dark'
      ? `linear-gradient(90deg, ${alpha(theme.palette.primary.dark, 0.18)} 0%, ${alpha(theme.palette.background.paper, 0.7)} 100%)`
      : `linear-gradient(90deg, ${alpha(theme.palette.primary.lighter, 0.28)} 0%, #fff 100%)`,
    boxShadow: theme.shadows[4],
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
  }),
  // activeSub
  ...(activeSub && {
    ...theme.typography.subtitle2,
    color: theme.palette.text.primary,
  }),
  // subItem
  ...(subItem && {
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
    paddingLeft: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      background: theme.palette.action.hover,
      color: theme.palette.primary.main,
    },
  }),
}));

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isCollapse',
})(({ isCollapse, theme }) => ({
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: ICON.NAVBAR_ITEM,
  height: ICON.NAVBAR_ITEM,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': { width: '100%', height: '100%' },
});
